module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/big_image@2x.a17ee50.jpg";